export default __webpack_public_path__ + "static/media/family-tour.1fd28fe3.png";